module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.userDetails) ? _c('div', [_c('div', {
    staticClass: "jumbotron"
  }, [_c('h1', {
    staticClass: "display-4 text-center"
  }, [_vm._v(_vm._s(_vm.userDetails.nickname))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('mission.community')))]), _vm._v(" "), _c('p', [(_vm.userDetails.community) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'communityDetails',
        params: {
          communitySlug: _vm.userDetails.community.slug
        }
      }
    }
  }, [_vm._v("[" + _vm._s(_vm.userDetails.community.tag) + "] " + _vm._s(_vm.userDetails.community.name))]) : _vm._e(), _vm._v(" "), (!_vm.userDetails.community) ? _c('span', {
    staticClass: "text-muted font-italic"
  }, [_vm._v(_vm._s(_vm.$t('account.notAssociated')))]) : _vm._e()], 1)]), _vm._v(" "), (_vm.isUserAdmin) ? _c('div', {
    staticClass: "col"
  }, [_c('h5', [_c('i', {
    staticClass: "fa fa-steam-square",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('user.steamId')))]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": ("https://steamcommunity.com/profiles/" + (_vm.userDetails.steamId)),
      "target": "_blank"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.userDetails.steamId) + "\n            ")])])]) : _vm._e(), _vm._v(" "), (_vm.isUserAdmin) ? _c('div', {
    staticClass: "col"
  }, [_c('h5', [_c('i', {
    staticClass: "fa fa-flag",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('user.status')) + "\n          ")]), _vm._v(" "), _c('p', {
    class: {
      'text-success': _vm.userDetails.active, 'text-danger': !_vm.userDetails.active
    }
  }, [_c('i', {
    staticClass: "fa",
    class: {
      'fa-check': _vm.userDetails.active, 'fa-times': !_vm.userDetails.active
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.userDetails.active ? _vm.$t('user.status.normal') : _vm.$t('user.status.deactivated')) + "\n          ")])]) : _vm._e()]), _vm._v(" "), (_vm.isUserAdmin) ? _c('hr', {
    staticClass: "my-4"
  }) : _vm._e(), _vm._v(" "), (_vm.isUserAdmin) ? _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.userEditModal",
      modifiers: {
        "userEditModal": true
      }
    }],
    attrs: {
      "variant": "primary"
    }
  }, [_c('i', {
    staticClass: "fa fa-edit",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.edit')) + "\n        ")]), _vm._v(" \n        "), (_vm.userDetails.active) ? _c('click-confirm', {
    attrs: {
      "yes-icon": "fa fa-user-times",
      "yes-class": "btn btn-warning",
      "button-size": "sm",
      "messages": {
        title: _vm.$t('user.confirm.deactivate'),
        yes: _vm.$t('button.confirm'),
        no: _vm.$t('button.cancel')
      }
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.modifyUserStatus(false)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user-times",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.deactivate.user')) + "\n          ")])], 1) : _vm._e(), _vm._v(" "), (!_vm.userDetails.active) ? _c('click-confirm', {
    attrs: {
      "yes-icon": "fa fa-user-plus",
      "yes-class": "btn btn-success",
      "button-size": "sm",
      "messages": {
        title: _vm.$t('user.confirm.activate'),
        yes: _vm.$t('button.confirm'),
        no: _vm.$t('button.cancel')
      }
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": function($event) {
        _vm.modifyUserStatus(true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.activate.user')) + "\n          ")])], 1) : _vm._e(), _vm._v(" \n        "), _c('click-confirm', {
    attrs: {
      "yes-icon": "fa fa-trash",
      "yes-class": "btn btn-danger",
      "button-size": "sm",
      "messages": {
        title: _vm.$t('user.confirm.delete'),
        yes: _vm.$t('button.confirm'),
        no: _vm.$t('button.cancel')
      }
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.deleteUser
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.delete.user')) + "\n          ")])], 1)], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block text-nowrap"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.$t('nav.missions')))]), _vm._v(" "), _c('user-missions')], 1)])]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.isUserAdmin) ? _c('user-edit-modal') : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31f37bc1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/UserDetails.vue
// module id = 496
// module chunks = 0